/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";
import { Contractor } from "@/models/api/Contractor";
import { getLocalContractor, getOfficeContractor } from "@/requests/contractors";

export interface ContractorsStateInterface {
  officeContractor: null | Contractor;
}

export const ContractorsState: ContractorsStateInterface = {
  officeContractor: null,
};

const ContractorsModule = defineModule({
  state: ContractorsState as ContractorsStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setOfficeContractor(state, param: null | Contractor) {
      state.officeContractor = param;
    },
  },
  actions: {
    async getOfficeContractor(context): Promise<Contractor> {
      const { commit, state } = _moduleActionContext(context);
      if (state.officeContractor === null) {
        commit.setOfficeContractor(await getOfficeContractor());
      }
      return state.officeContractor as Contractor;
    },
    async getLocalContractor(context, localContractorId: number): Promise<Contractor> {
      return await getLocalContractor(localContractorId);
    },
  },
});

export default ContractorsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, ContractorsModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, ContractorsModule);
